import { render, staticRenderFns } from "./EventPlaces.vue?vue&type=template&id=4f2343ce"
import script from "./EventPlaces.vue?vue&type=script&lang=js"
export * from "./EventPlaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports